import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import legacyRedirects from '../config/legacyRedirects.json';

// PageSeo runs before this component so virtual views include the current title.
export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const pagePath = pathname.replace(/\/+$/, '') || '/';
    if (process.env.NODE_ENV !== 'production' || lastPath.current === pagePath || legacyRedirects[pagePath]) return;
    const gtmId = (process.env.REACT_APP_GTM_ID || '').trim();
    const ga4Id = (process.env.REACT_APP_GA4_MEASUREMENT_ID || '').trim();
    lastPath.current = pagePath;
    const page = {
      page_title: document.title,
      page_location: `${window.location.origin}${pagePath}`,
      page_path: pagePath
    };

    if (/^GTM-[A-Z0-9]+$/.test(gtmId)) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'virtual_page_view', ...page });
    } else if (/^G-[A-Z0-9]+$/.test(ga4Id) && typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { send_to: ga4Id, ...page });
    }
  }, [pathname]);

  return null;
}
